import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import PaymentSelling from "../../../containers/modules/sales/payment-selling";

export default function PaymentInvoiceRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="payment-invoice"
      index
      element={
        <AccessControl
          name={"Payment Confirmation List"}
          auth={authUser}
          component={() => <PaymentSelling />}
        />
      }
    />
  );
}
